//src/mis/pages/RegisterUser.jsx
import { tokens } from "../../theme";
import Modal from '@mui/material/Modal';
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  useMediaQuery,
  Typography,
  useTheme,
  Chip,
  InputLabel,
  Select,
  FormControl,
  IconButton,
  Snackbar,
  Alert,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Autocomplete
} from "@mui/material";
import { Formik } from "formik";
import MenuItem from '@mui/material/MenuItem';
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import env from "react-dotenv";
import { CloseRounded } from "@mui/icons-material";


const registerSchema = yup.object().shape({
    fullName: yup.string().required("required"),
    email: yup.string().email("invalid email"),
    password: yup.string().required("required"),
    // department: yup.string().required("required"),
    department: yup.array().required("required"), // Change to array for multiple selection
    role: yup.string().required("required"),
    mobile: yup.string().required("required"),
  });
  
  
  const initialValuesRegister = {
    fullName: "",  
    email: "",
    password: "",
    // department: "",
    department: [], // Change to an array for multiple selection
    role:"",
    mobile:"",
  };  

const Register = ({open , onClose, departments }) => {
  const location = useLocation();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [pageType, setPageType] = useState("register");
  const { palette } = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const isLogin = pageType === "login";
  const isRegister = pageType === "register";
  const [backenderrors, setBackenderrors] = useState({});
  const [mobileExists, setMobileExists] = useState(null);
  const [errors, setErrors] = useState({});
  const [mobiles , setMobiles] = useState([]);
  
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );


  useEffect( () => {
    const fetchMobiles = async() =>{
        try {
            const res = await fetch(
                `${process.env.REACT_APP_USERMGMT_URL}/notes`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  }
                }
              )
              const response = await res.json();
              
              setMobiles(Object.keys(response).map(function(k){
                return (response[k].mobile)
              })); 
             
        }
        catch(error){
            console.log('Error fetching mobile numbers',error);
        }
    }
    fetchMobiles();  
  }, [ ] );

  const getUserFromDB = async (mobile) => {
   
    try { 
       const res = await fetch(
         `${process.env.REACT_APP_USERMGMT_URL}/userByMobile/${mobile}`,
         {
           method: "GET",
           headers: {
             "Content-Type": "application/json",
           }
         }
       )
       const response = await res.json();
       setMobileExists(response.id);
         
     } catch (error) {
       console.log(error);
     }
   } 


  const register = async (values) => {
    // this allows us to send form info with image
    // Convert the selected departments array to a comma-separated string
    const valuesToSubmit = {
      ...values,
      department: values.department.join(', '), // Join selected departments
    };

      const newErrors = {};
      if(values.mobile !== null){
        const mobileExists = mobiles.includes(values.mobile);
        if(mobileExists){
            newErrors.mobile = "Mobile Number already exists";        
        } 
      }          
      setBackenderrors(newErrors);
  
    if (Object.keys(newErrors).length === 0) {
        const savedUserResponse = await fetch(`${process.env.REACT_APP_USERMGMT_URL}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify(values),
        body: JSON.stringify(valuesToSubmit), // Use the modified values
        });
          const savedUser = await savedUserResponse.json();
          //onSubmitProps.resetForm();    
          navigate(0);
          navigate("../register");      
    }    
  };

  // const handleFormSubmit = async (values, onSubmitProps) => {
    
  //   if (isRegister) await register(values, onSubmitProps);
  // };
  const handleFormSubmit = async (values) => {
    await register(values);
  };
  
  return (open) ? (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
            Add User
          </Typography>
          <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseRounded />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>

     <Formik
      onSubmit={handleFormSubmit}
      initialValues={initialValuesRegister}
      validationSchema={registerSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        resetForm,
      }) => (
        <form onSubmit={handleSubmit}> 
          <Box
            display="grid"
            gap="15px"
            gridTemplateColumns="repeat(3, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
              marginRight: "10px",
              marginLeft:"10px",
              marginBottom:"10px",
            }}
          >

                <TextField
                  label="Full Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.fullName}
                  name="fullName"
                  error={
                    Boolean(touched.fullName) && Boolean(errors.fullName)
                  }
                  helperText={touched.fullName && errors.fullName}
                  sx={{ gridColumn: "span 3" }}
                />
            
                  {/* <TextField
                  label="Department"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.department}
                  name="department"
                  error={Boolean(touched.department) && Boolean(errors.department)}
                  helperText={touched.department && errors.department}
                  sx={{ gridColumn: "span 3", textAlign:"left" }}
                  select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    
                  }}
                >   */}
                  {/* <MenuItem default disabled value="choose">Choose Option</MenuItem> */}
                  {/* {menuvalues.map((value) => (
                    <MenuItem value={value} key={value}>{value}</MenuItem>
                  ))}
                
                  </TextField> */}

                {/* <TextField
                  label="Department"
                  onBlur={handleBlur}
                  onChange={(event) => {
                    const value = event.target.value;
                    setFieldValue("department", typeof value === 'string' ? value.split(',') : value);
                  }}
                  value={values.department}
                  name="department"
                  error={Boolean(touched.department) && Boolean(errors.department)}
                  helperText={touched.department && errors.department}
                  sx={{ gridColumn: "span 3", textAlign: "left" }}
                  select
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => (
                      <div>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </div>
                    ),
                  }}
                >
                  {departments.map((dept) => (
                    <MenuItem key={dept.id} value={dept.dept_name}>
                      {dept.dept_name}
                    </MenuItem>
                  ))}
                </TextField> */}
                <Autocomplete
                  multiple
                  options={departments.map(d => d.dept_name)}
                  value={values.department}
                  onChange={(e, value) => setFieldValue("department", value)}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                        sx={{
                          backgroundColor: '#e0f7fa',
                          color: '#00796b',
                          '& .MuiChip-deleteIcon': {
                            color: '#004d40',
                          },
                        }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Department"
                      placeholder="Select Department"
                      error={Boolean(touched.department) && Boolean(errors.department)}
                      helperText={touched.department && errors.department}
                      sx={{ gridColumn: "span 3", textAlign: "left" }}
                    />
                  )}
                  sx={{ gridColumn: "span 3" }}
                />

                {/* <FormControl sx={{ gridColumn: "span 3", textAlign: "left" }}>
                  <InputLabel id="department-label">Department</InputLabel>
                  <Select
                    labelId="department-label"
                    multiple
                    value={values.department}
                    onChange={(event) => {
                      const {
                        target: { value },
                      } = event;
                      setFieldValue("department", typeof value === 'string' ? value.split(',') : value);
                    }}
                    renderValue={(selected) => (
                      <div>
                        {selected.map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            onDelete={() => {
                              const newDepartments = values.department.filter((dept) => dept !== value);
                              setFieldValue("department", newDepartments);
                            }}
                          />
                        ))}
                      </div>
                    )}
                  >
                    {departments.map((dept) => (
                      <MenuItem key={dept.id} value={dept.dept_name}>
                        {dept.dept_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
               
                  <TextField
                  label="Role"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.role}
                  name="role"
                  error={Boolean(touched.role) && Boolean(errors.role)}
                  helperText={touched.role && errors.role}
                  sx={{ gridColumn: "span 3", textAlign:"left" }}
                  select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    
                  }}
                >
                    {/* <MenuItem value="Maintenance Admin" key="admin">Maintenance Admin</MenuItem>
                    <MenuItem value="Supply Admin" key="supplyadmin">Supply Admin</MenuItem>
                    <MenuItem value="Production Admin" key="prodadmin">Production Admin</MenuItem>
                    <MenuItem value="Read Only" key="readOnly">Read Only</MenuItem> */}

                    <MenuItem value="">No selection</MenuItem>
                    <MenuItem value="Admin" key="admin">Admin</MenuItem>
                    <MenuItem value="Super Admin" key="superadmin">Super Admin</MenuItem>
                    <MenuItem value="Operator" key="operator">Operator</MenuItem>
                    <MenuItem value="Supervisor" key="supervisor">Supervisor</MenuItem>

                  </TextField>
                  
              <TextField
              label="Mobile Number"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.mobile}
              name="mobile"
              error={Boolean(touched.mobile) && Boolean(errors.mobile)}
              helperText={touched.mobile && errors.mobile}
              sx={{ gridColumn: "span 3" }}
            />
            {backenderrors.mobile &&
                        <span style={{ color: 'red'}} className="error-message">
                            {backenderrors.mobile}
                        </span>
            }

          <TextField
              label="Email"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.email}
              name="email"
              error={Boolean(touched.email) && Boolean(errors.email)}
              helperText={touched.email && errors.email}
              sx={{ gridColumn: "span 3" }}
            />

            <TextField
              label="Password"
              type="password"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.password}
              name="password"
              error={Boolean(touched.password) && Boolean(errors.password)}
              helperText={touched.password && errors.password}
              sx={{ gridColumn: "span 3" }}
            />

            </Box>

            <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={onClose} color="secondary"
                    sx={{ marginRight: 2,':hover': {
                                  bgcolor: '#4863C0', // theme.palette.primary.main
                                  color: 'white',
                        }, }}
                    >
                      Cancel
                    </Button>
             <Button
              type="submit"
              sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
              },}} 
              variant="contained"
            >
              {isLogin ? "LOGIN" : "REGISTER"}
            </Button>
            </DialogActions>

          {/* BUTTONS */}
          <Box
           
          >
           
            <Typography
              onClick={() => {
                setPageType(isLogin ? "register" : "login"); 
                
                resetForm();
              }}
              sx={{
                mr: 5,
                textDecoration: "underline",
                color: palette.primary.main,
                "&:hover": {
                  cursor: "pointer",
                  color: palette.primary.light,
                },
              }}
            >
            {/* {isLogin
                ? "Don't have an account? Sign Up here."
                : "Already have an account? Login here."}             */}
                </Typography> 
          </Box>
        </form>
      )}
    </Formik>   
    </DialogContent>
  </Dialog>  
  ): ""
  
};

export default Register;